import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

/**
 * PSS minute voting (draft / final meeting minutes). Uses same secure URL base as agenda voting.
 */
@Injectable({
  providedIn: 'root',
})
export class MinuteVoteService {
  private readonly base = environment.pssServerUrl;

  constructor(private http: HttpClient) {}

  submitMinuteVote(voteData: object): Promise<any> {
    return this.http
      .post(this.base + 'minuteVote/submit', voteData)
      .toPromise()
      .catch((e) => Promise.reject(e));
  }

  getMinuteVoteSummary(meetingID: string, minuteType: string): Promise<any> {
    return this.http
      .get(this.base + 'minuteVote/summary/' + meetingID + '/' + minuteType)
      .toPromise()
      .catch((e) => Promise.reject(e));
  }

  getMeetingMinuteVoteSummary(meetingID: string): Promise<any> {
    return this.http
      .get(this.base + 'minuteVote/meeting/' + meetingID)
      .toPromise()
      .catch((e) => Promise.reject(e));
  }

  retractMinuteVote(meetingID: string, minuteType: string): Promise<any> {
    return this.http
      .delete(this.base + 'minuteVote/retract/' + meetingID + '/' + minuteType)
      .toPromise()
      .catch((e) => Promise.reject(e));
  }

  getMinuteVoteEligibility(meetingID: string, minuteType: string): Promise<any> {
    return this.http
      .get(this.base + 'minuteVote/eligibility/' + meetingID + '/' + minuteType)
      .toPromise()
      .catch((e) => Promise.reject(e));
  }

  updateMinuteVoteEligibility(
    meetingID: string,
    minuteType: string,
    payload: { eligibleUserIds: string[] }
  ): Promise<any> {
    return this.http
      .put(this.base + 'minuteVote/eligibility/' + meetingID + '/' + minuteType, payload)
      .toPromise()
      .catch((e) => Promise.reject(e));
  }
}
